import { env } from "../config/env";
import {
  getAuthHeaders,
  getAuthToken,
} from "../pages/AdminAuth/components/authStore";

const BASE = env?.AUTH_BASE_URL ;

function buildUrl(path, params = {}) {
  const url = new URL(`${BASE}${path}`);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      url.searchParams.set(key, value);
    }
  });
  return url.toString();
}

async function request(path, options = {}) {
  const token = getAuthToken?.();
  const headers = {
    "Content-Type": "application/json",
    ...(getAuthHeaders ? getAuthHeaders() : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options.headers || {}),
  };

  const res = await fetch(path, {
    ...options,
    headers,
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data?.message || "Request failed");
  }

  return data;
}

function normalizeUser(item = {}) {
  const address = item?.address || item?.permanentAddress || {};

  return {
    id: item?.id || item?._id || "",
  userCode:
  item?.userCode ||
  item?.userId ||
  item?.customerCode ||
  item?.code ||
  "-",
    name: item?.name || item?.fullName || "-",
    email: item?.email || "-",
    phone: item?.phone || item?.mobile || "",
    status: String(item?.status || (item?.isBlocked ? "BLOCKED" : "ACTIVE")).toUpperCase(),
    isActive: item?.isActive !== false,
    profileCompleted: Boolean(
      item?.profileCompleted ??
        item?.isProfileCompleted ??
        item?.hasCompletedProfile
    ),
    profileCompletedLabel: Boolean(
      item?.profileCompleted ??
        item?.isProfileCompleted ??
        item?.hasCompletedProfile
    )
      ? "Completed"
      : "Pending",
    lastLogin: item?.lastLoginAt || item?.lastLogin || "",
    lastLoginLabel: item?.lastLoginAt || item?.lastLogin
      ? new Date(item?.lastLoginAt || item?.lastLogin).toLocaleString()
      : "-",
    addressType: address?.addressType || "HOME",
    addressLine1: address?.addressLine1 || address?.line1 || "",
    addressLine2: address?.addressLine2 || address?.line2 || "",
    landmark: address?.landmark || "",
    city: address?.city || "",
    district: address?.district || "",
    state: address?.state || "",
    pincode: address?.pincode || "",
    latitude:
      address?.latitude ??
      address?.lat ??
      item?.latitude ??
      item?.lat ??
      "",
    longitude:
      address?.longitude ??
      address?.lng ??
      item?.longitude ??
      item?.lng ??
      "",
  };
}

export const UsersService = {
  async list(params = {}) {
    const data = await request(
      buildUrl("/api/user-auth/admin/users", params),
      { method: "GET" }
    );

    const rawItems =
      data?.items || data?.users || data?.data || data?.rows || [];

    return {
      ...data,
      items: Array.isArray(rawItems) ? rawItems.map(normalizeUser) : [],
    };
  },

  async getById(id) {
    const data = await request(`${BASE}/api/user-auth/admin/users/${id}`, {
      method: "GET",
      headers: getAuthHeaders ? getAuthHeaders() : {},
    });

    return normalizeUser(data?.item || data?.user || data?.data || data);
  },

  async update(id, payload) {
    const data = await request(`${BASE}/api/user-auth/admin/users/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });

    return data;
  },


  async block(id) {
    return request(`${BASE}/api/user-auth/admin/users/${id}/block`, {
      method: "PATCH",
    });
  },

  async unblock(id) {
    return request(`${BASE}/api/user-auth/admin/users/${id}/unblock`, {
      method: "PATCH",
    });
  },

  async activate(id) {
    return request(`${BASE}/api/user-auth/admin/users/${id}/activate`, {
      method: "PATCH",
    });
  },

  async deactivate(id) {
    return request(`${BASE}/api/user-auth/admin/users/${id}/deactivate`, {
      method: "PATCH",
    });
  },
};